module.exports = __webpack_public_path__ + "img/selected_icon.33a03ce1.svg";